import getDefaultTheme from "./getDefaultTheme";
import ThemeContext from "@suid/system/ThemeContext";
import useSysTheme from "@suid/system/useTheme";
function useTheme(defaultTheme = getDefaultTheme) {
    return useSysTheme(defaultTheme, ThemeContext);
}
export default useTheme;
